import React from 'react';
import {
  ButtonTertiary,
  IconChevronLeft,
  cssColorValue,
  cssSpacing,
  screenSmMin,
  semanticColors,
} from '@spotify-internal/encore-web/core';
import styled from 'styled-components';

import PageContainer from 'components/PageContainer';
import { ArticleCategoryMetadata, ParentCategory } from 'lib/sanity/types';

import { ArticleCategories } from '.';

const CategoriesSmallWrapper = styled(PageContainer)<{ $isDisplayed: boolean }>`
  align-items: center;
  display: ${({ $isDisplayed }) => ($isDisplayed ? 'flex' : 'none')};
  flex-direction: column;
  gap: 40px;

  @media (min-width: ${screenSmMin}) {
    display: none;
  }
`;

const BackToArticleButton = styled(ButtonTertiary)`
  align-self: flex-start;
  font-size: 14px;
  padding-inline-start: 0;
`;

const IconWrapper = styled.span`
  background-color: ${cssColorValue(semanticColors.decorativeSubdued)};
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  padding: ${cssSpacing('tighter-2')};
`;

interface Props {
  isDisplayed: boolean;
  categories: ParentCategory[];
  onBackToArticle?: () => void;
  categoryMetadata?: ArticleCategoryMetadata | null;
}

export const ArticleCategoriesSmallView = ({ categories, categoryMetadata, onBackToArticle, isDisplayed }: Props) => {
  return (
    <CategoriesSmallWrapper $isDisplayed={isDisplayed}>
      {onBackToArticle && (
        <BackToArticleButton
          onClick={onBackToArticle}
          semanticColor="textBase"
          iconLeading={() => (
            <IconWrapper>
              <IconChevronLeft size="small" />
            </IconWrapper>
          )}
        >
          Back to article
        </BackToArticleButton>
      )}
      <ArticleCategories categories={categories} categoryMetadata={categoryMetadata} />
    </CategoriesSmallWrapper>
  );
};
